import { useCallback } from "react";
import useApiClient from "../services/axiosInstance";

export const useFinacialPortfolioService = () => {
  const { api } = useApiClient();

  const fetchFinancialPortfolioDetails = useCallback(
    async (data) => {
      try {
        const response = await api.post("/api/portfolio/fetch", data);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    [api]
  );
  return { fetchFinancialPortfolioDetails };
};
